import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppNavigation } from '../../hooks/useAppNavigation';
import Menu from './components/Menu';

export const MenuPage: React.FC = () => {
  const { goHome } = useAppNavigation();
  const navigate = useNavigate();

  return (
    <Menu
      onNavigateToProfile={() => navigate('/menu/profile')}
      onNavigateToFamilyList={() => navigate('/menu/families')}
      onBack={goHome}
    />
  );
};

export default MenuPage;
